import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.9975 19.0029H4.99708C3.89162 19.0029 2.99625 18.1075 2.99625 17.0021V7.18399C2.99625 6.07853 3.89162 5.18316 4.99708 5.18316H5.9975"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2631 19.0029H19.0029C20.1084 19.0029 21.0037 18.1075 21.0037 17.0021V7.18399C21.0037 6.07853 20.1084 5.18316 19.0029 5.18316H12.2631"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2623 21.0037H7.99833C6.89287 21.0037 5.9975 20.1084 5.9975 19.0029V4.99708C5.9975 3.89162 6.89287 2.99625 7.99833 2.99625H10.2623C11.3677 2.99625 12.2631 3.89162 12.2631 4.99708V19.0029C12.2631 20.1084 11.3677 21.0037 10.2623 21.0037Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0013 8.99875H18.0025"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0513 12.4002C15.0793 12.4002 15.1013 12.4222 15.1013 12.4502C15.1013 12.4782 15.0793 12.5002 15.0513 12.5002C15.0233 12.5002 15.0012 12.4782 15.0012 12.4502C15.0012 12.4232 15.0233 12.4002 15.0513 12.4002"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0513 14.9012C15.0793 14.9012 15.1013 14.9232 15.1013 14.9512C15.1013 14.9792 15.0793 15.0012 15.0513 15.0012C15.0233 15.0012 15.0012 14.9792 15.0012 14.9512C15.0012 14.9242 15.0233 14.9012 15.0513 14.9012"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9525 12.4002C17.9805 12.4002 18.0025 12.4222 18.0025 12.4502C18.0025 12.4782 17.9805 12.5002 17.9525 12.5002C17.9245 12.5002 17.9024 12.4782 17.9024 12.4502C17.9014 12.4222 17.9245 12.4002 17.9525 12.4002"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9525 14.9012C17.9805 14.9012 18.0025 14.9232 18.0025 14.9512C18.0025 14.9792 17.9805 15.0013 17.9525 15.0013C17.9245 15.0013 17.9024 14.9792 17.9024 14.9512C17.9014 14.9232 17.9245 14.9012 17.9525 14.9012"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgComponent
